import { Link } from 'react-router-dom';

interface LogoLinkProps {
  dashboard?: boolean;
  admin?: boolean;
}

export const LogoLink = (props: LogoLinkProps) => {
  const { dashboard, admin } = props;

  let url = '/';
  if (dashboard) {
    if (admin) {
      url = '/dashboard/admin/last';
    } else {
      url = '/dashboard/last';
    }
  }
  return (
    <Link to={url}>
      <img src='/logo.svg' alt='TLS Poisk' width={'200px'}/>
    </Link>
  );
};
